//--------------------------------------------------
// imported classes
//--------------------------------------------------
const MatchTeam = require('@/tbs/model/to/MatchTeam')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Match class works as the organization translator.
 */
const tbs_model_to_Match = function () {
  ClassFunc.super(this, MatchTeam, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Match.prototype = {
  'match-organization-label': '办赛机构',
  'match-organization-required': '请选择机构',
  'match-brand-label': '品牌赛事',
  'match-brand-required': '请选择品牌赛事',
  'match-year-label': '年份',
  'match-session-label': '届数',
  'match-name-label': '预览/修改赛事展示名',
  'match-name-prompt': '由[年][届]自动合并生成，可修改',
  'match-name-pattern': '$year年第$session届$brand',
  'match-name-required': '请输入赛事名称',
  'match-brand-crowd-option-1': '青训',
  'match-brand-crowd-option-2': '校园',
  'match-brand-crowd-option-3': '社区',
  'match-brand-crowd-option-4': '企业',
  'match-brand-crowd-option-99': '其他',
  'match-brand-name-label': '品牌赛事',
  'match-brand-name-placeholder': '品牌赛事名称',
  'match-brand-name-required': '请填写品牌赛事名称',
  'match-brand-logo-label': '品牌赛事LOGO',
  'match-brand-logo-placeholder': '建议使用PNG格式，背景透明图片，图片大小400X400 PX',
  'match-brand-logo-required': '请上传品牌赛事LOGO',
  'match-brand-area-required': '请选择城市区域',
  'match-brand-crowd-label': '人群属性',
  'match-brand-crowd-required': '请选择人群属性',
  'match-brand-empty-hint': '暂无可选品牌赛事，请先新建品牌赛事',
  'delete-match-brand': '删除品牌赛事',
  'delete-match-brand-confirm-message': '确认删除该品牌赛事，无法进行还原',
  'create-match-name-label': '立即新建，完善基础信息',
  'match-num-selection-label': '赛事人制',
  'match-number-selection': '$num人制',
  'change-number-selection': '修改赛事人制',
  'change-number-selection-confirm-message': '该项操作会重置赛事规则中“半场时间”，“中场时间”等关联部分，是否确认进行修改？',
  'match-num-selection-required': '请选择赛事人制',
  'change-match-rule-confirm-message': '该项操作会重置赛事规则中有关联的部分，是否确认进行修改？',
  'match-type-label': '赛事类型',
  'match-type-option-1': '联赛',
  'match-type-option-2': '杯赛',
  'match-type-required': '请选择赛事类型',
  'change-type': '修改赛事类型',
  'change-type-confirm-message': '该项操作会重置赛事规则中“赛制类型”，“分组”（若有），“淘汰赛队伍”（若有）等关联部分，是否确认进行修改？',
  'change-spec-type': '修改赛制类型',
  'change-spec-type-confirm-message': '该项操作会重置赛事规则中“分组”（若有），“淘汰赛队伍”（若有）等关联部分，是否确认进行修改？',
  'match-start-date-label': '开赛日期',
  'match-end-date-label': '结束日期（可选）',
  'match-date-format': 'yyyy年MM月dd日',
  'match-start-date-required': '请选择开赛日期',
  'match-team-total-label': '球队数',
  'match-team-total-placeholder': '总球队数',
  'match-team-total-required': '请填写球队数',
  'change-team-total': '修改球队数',
  'change-team-total-confirm-message': '该项操作会重置赛事规则中“分组”（若有），“淘汰赛队伍”（若有）等关联部分，是否确认进行修改？',
  'match-status-option-1': '筹备中',
  'match-status-option-2': '进行中',
  'match-status-option-3': '已结束',
  'match-empty-hint': '暂无赛事',
  'match-publish-status-option-1': '待发布',
  'match-publish-status-option-2': '已上线',
  'switch-match-1': '切换赛事上线',
  'switch-match-2': '切换赛事下线',
  'switch-match-confirm-message-1': '赛事“待发布”中，上线后用户可以查看赛事',
  'switch-match-confirm-message-2': '赛事“已上线”中，下线后用户无法查看赛事',
  'base-info': '基础信息',
  'match-info': '办赛信息',
  'summary-info': '简介说明',
  'match-info-title': '办赛信息（可选）',
  'summary-info-title': '简介说明（可选）',
  'match-logo-label': '赛事LOGO',
  'match-logo-placeholder': '建议使用PNG格式，背景透明图片，图片大小400X400 PX',
  'match-poster-label': '海报图',
  'match-poster-placeholder': '建议使用JPG格式，允许使用动图，图片大小600X300 PX',
  'presenter-unit-label': '主办单位',
  'presenter-unit-placeholder': '主办单位名称',
  'organizer-unit-label': '承办单位',
  'organizer-unit-placeholder': '承办单位名称',
  'coorganizer-unit-label': '协办单位',
  'coorganizer-unit-placeholder': '协办单位名称',
  'advisor-unit-label': '指导单位',
  'advisor-unit-placeholder': '指导单位名称',
  'match-summary-placeholder': '赛事历史，过往成绩，赛事故事……',
  'delete-match': '删除赛事',
  'delete-match-confirm-message': '确认删除该赛事，无法进行还原',
  'competition-format': '赛事&赛制',
  'match-spec-type-label': '赛制类型',
  'match-spec-type-option-1': '单循环',
  'match-spec-type-option-2': '双循环',
  'match-spec-type-option-3': '小组（单循环）+淘汰赛',
  'match-spec-type-option-4': '小组（双循环）+淘汰赛',
  'match-spec-type-option-5': '淘汰赛',
  'round-num-label': '总轮数',
  'group-num-label': '分组',
  'change-group-num': '修改分组数',
  'change-group-num-confirm-message': '该项操作会重置赛事规则中“淘汰赛队伍”（若有）等关联部分，是否确认进行修改？',
  'group-name-type-label': '组名',
  'group-name-type-option-1': '第1组，第2组，…，第N组',
  'group-name-set-type-1': '第1组,第2组,第3组,第4组,第5组,第6组,第7组,第8组,第9组,第10组,第11组,第12组,第13组,第14组,第15组,第16组,第17组,第18组,第19组,第20组',
  'group-name-type-option-2': 'A组，B组，…，N组',
  'group-name-set-type-2': 'A组,B组,C组,D组,E组,F组,G组,H组,I组,J组,K组,L组,M组,N组,O组,P组,Q组,R组,S组,T组,U组,V组,W组,X组,Y组,Z组',
  'group-name-type-option-3': '甲组，乙组，…，癸组',
  'group-name-set-type-3': '甲组,乙组,丙组,丁组,戊组,己组,庚组,辛组,壬组,癸组',
  'group-name-type-option-4': 'I组，II组，…，XVI组',
  'group-name-set-type-4': 'I组,II组,III组,IV组,V组,VI组,VII组,VIII组,IX组,X组,XI组,XII组,XIII组,XIV组,XV组,XVI组,XVII组,XVIII组,XIX组,XX组',
  'group-round-num-label': '小组赛轮数',
  'group-round-num-desc': '分$group组，每组$team支队，共$round轮',
  'eliminated-team-num-label': '淘汰赛队伍',
  'change-eliminated-team-num': '修改淘汰赛队伍数',
  'change-eliminated-team-num-confirm-message': '该项操作会重置赛事规则中有关联的部分，是否确认进行修改？',
  'eliminated-round-num-label': '淘汰赛轮数',
  'eliminated-round-num-desc': '共$round轮',
  'draw-rank-type-label': '同分规则',
  'draw-rank-type-option-1': '胜负关系优先',
  'draw-rank-type-option-2': '净胜球优先',
  'draw-rank-type-option-3': '进球数优先',
  'period-time-label': '半场时间 ',
  'period-time-placeholder': '分钟',
  'period-gap-time-label': '中场时间 ',
  'period-gap-time-placeholder': '分钟',
  'point-type-label': '积分规则',
  'point-type-option-1': '胜3 平1 负0',
  'point-type-option-2': '胜3 点胜2 点负1 负0',
  'substitution-type-label': '换人规则',
  'substitution-type-option-1': '限制人数',
  'restriction-num-label': '人数限制',
  'restriction-num-placeholder': '人数',
  'restriction-num-type-option-1': '人/场',
  'restriction-num-type-option-2': '人/半场',
  'restriction-times-label': '次数限制',
  'restriction-times-placeholder': '次数',
  'restriction-times-type-option-1': '次/场',
  'restriction-times-type-option-2': '次/半场',
  'is-substitution-on-label': '换下可再换上',
  'substitution-type-option-2': '限制次数',
  'is-substitution-half-count-label': '半场换人算次数',
  'substitution-type-option-3': '无限换人',
  'substitution-type-option-4': '人数+次数',
  'substitution-total-label': '次数限制',
  'substitution-total-placeholder': '总换人次数',
  'substitution-total-type-option-1': '次/场',
  'substitution-total-type-option-2': '次/半场',
  'substitution-once-num-label': '单次换人限制',
  'substitution-once-num-placeholder': '每次人数',
  'other-rules': '其他规则',
  'other-rules-title': '其他规则',
  'spike-required-label': '鞋钉要求',
  'spike-ag-required-label': 'AG人工草场钉',
  'spike-tf-required-label': 'TF碎丁',
  'spike-mg-required-label': 'MG混合草钉',
  'spike-ic-required-label': 'IC室内鞋',
  'spike-hg-required-label': 'HG胶质短钉',
  'spike-fg-required-label': 'FG胶质长钉',
  'spike-sg-required-label': 'SG金属长钉',
  'leg-guard-required-label': '佩戴护腿板',
  'metal-forbidden-label': '禁止佩戴金属饰物',
  'data-display': '数据显示',
  'data-display-title': '数据显示',
  'data-mode-label': '数据展示模式',
  'data-mode-option-1': '时间轴事件',
  'data-mode-option-2': '数据汇总统计',
  'change-data-mode': '修改数据展示模式',
  'change-data-mode-confirm-message': '该项操作会重置赛事中已有比赛的数据等关联部分，是否确认进行修改？',
  'data-mode-presentation-sample': '图例',
  'round-seq': '第$seq轮',
  'league-game': '联赛',
  'round-game': '循环赛',
  'division-game': '小组赛',
  'division': '小组',
  'eliminated-game': '淘汰赛',
  'final-game': '决赛',
  'semi-final-game': '半决赛',
  'match-round-empty-hint': '该轮次暂无比赛，新建比赛',
  'round-number': '轮次数',
  'round-count-total': '$count / $total',
  'create-match': '新建比赛',
  'create-activity': '新建活动',
  'game-status-1': '未开始',
  'game-status-2': '已开始',
  'game-status-3': '已结束',
  'referee-alloc': '裁判分配',
  'live-setting': '直播设置',
  'record-score': '比分录入',
  'game-confirm': '比赛确认',
  'edit-game': '编辑比赛',
  'game-stats': '数据统计',
  'view-game': '查看比赛',
  'is-suspension-reminder-on-label': '红黄牌自动提醒',
  'match-suspension-yellow-num-label': '累计',
  'match-suspension-yellow-num-placeholder': '张',
  'match-suspension-yellow-game-num-label': '黄牌停赛',
  'match-suspension-yellow-game-num-placeholder': '场',
  'match-suspension-red-num-label': '累计',
  'match-suspension-red-num-placeholder': '张',
  'match-suspension-red-game-num-label': '红牌停赛',
  'match-suspension-red-game-num-placeholder': '场',
  'is-suspension-lead-knockout-label': '停赛带入淘汰赛',
  'suspension-report-num-label': '红黄牌&停赛报告',
  'report-empty-hint': '暂无停赛公告',
  'reminder-indication': '红黄牌提醒说明',
  'reminder-summary': '红黄牌提醒功能可以摆脱繁琐数据统计工作，帮助组委会提升工作效率。开通后你将获得：',
  'reminder-item-1': '1 自由配置红黄牌的停赛场次',
  'reminder-item-2': '2 每轮次自动生成红黄牌球员表格',
  'reminder-item-3': '3 每轮次自动停赛人员列表',
  'reminder-item-4': '4 鼓励赛事参赛球队的队员入驻斑马邦，这样即可收到以上提醒表格的系统消息推送',
  'create-match-brand': '新建品牌赛事',
  'history-match-brand-list': '品牌赛列表',
  'edit-round-num': '已编辑 $num 轮',
  'total-round-num': '总 $num 轮',
  'advisor-service': '专属顾问',
  'preview-match': '预览赛事',
  // 赛事详情/首页场景（team/live 见 Live.js、MatchTeam.js）
  'more': '更多',
  'recent-games': '近期比赛',
  'match-group': '组别设置',
  'news-announcement': '新闻公告',
  'basic-info': '基本信息',
  'supervisor': '指导单位',
  'endorser': '主办方',
  'contactor': '承办方',
  'coorganizer': '协办方',
  'regulations': '竞赛规程',
  'registration': '赛事报名',
  'reg-deadline': '报名截止',
  'reg-deadline-closed': '已截止',
  'reg-fee': '报名费用',
  'reg-groups': '组别',
  'reg-open-at': '开启报名',
  'reg-view-now': '立即报名',
  'reg-view': '查看我的报名',
  'reg-start-time-tip': '报名开始时间：',
  'rank-champion': '冠军',
  'rank-runner-up': '亚军',
  'rank-third': '季军',
  'score-announcement': '成绩公告',
}

//--------------------------------------------------
// extends the MatchTeam（含 Live 直播场景、球队展示场景）
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Match, MatchTeam)

module.exports = tbs_model_to_Match